import { TFunction } from '@lyearn/i18n';
import { GlobeFill, Lock2Outline } from '@lyearn/icons';
import { AssignmentRestrictionTypeEnum } from '@/types/schema';

import { SettingsTabType } from '../../VisibilitySettings/components/VisibilitySettingsTabs/types';

export const getSettingTabTypes = (t: TFunction): SettingsTabType[] => [
  {
    id: AssignmentRestrictionTypeEnum.All,
    label: t('AssignmentRestriction:AllStaffRoles'),
    Icon: GlobeFill,
  },
  {
    id: AssignmentRestrictionTypeEnum.Restricted,
    label: t('AssignmentRestriction:SpecificRoles'),
    Icon: Lock2Outline,
  },
];
